const PhotoListHeader = () => {
  return (
    <div
      style={{
        width: "90%",
        marginBottom: "15px",
        fontFamily: "PretendardB",
      }}
    >
      <div>Photo List</div>
    </div>
  );
};

export default PhotoListHeader;
